import { render } from "./ResultFun.vue?vue&type=template&id=2ec77094&scoped=true"
import script from "./ResultFun.vue?vue&type=script&lang=js"
export * from "./ResultFun.vue?vue&type=script&lang=js"

import "./ResultFun.vue?vue&type=style&index=0&id=2ec77094&lang=scss&scoped=true"

import exportComponent from "/Users/konatsu/docker-static/speedo.devs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ec77094"]])

export default __exports__